import { getMaxRiskScoresInList } from '@omnea-app/packages/universal/risks/getMaxRiskScoresInList'
import { RiskMethodologyCalculatorFactory } from '../edit/shared/form/sections/risk-level/chips/content/data/RiskMethodologyCalculatorFactory'
import { useGetRiskSettings } from '../settings/hooks/useGetRiskSettings'
import type { MaxRiskScore, SummaryRiskScores } from '@omnea-app/packages/universal/risks/getMaxRiskScoresInList'

export type { MaxRiskScore }

type Output = {
  getMaxRiskScoresInList: (risks?: SummaryRiskScores[] | null) => MaxRiskScore | null
}

export const useGetMaxRiskScoresInList = (): Output => {
  const riskSettings = useGetRiskSettings().data
  const methodology = RiskMethodologyCalculatorFactory(riskSettings?.riskScoreMethodology).getMethodology()

  return { getMaxRiskScoresInList: (risks) => getMaxRiskScoresInList(risks, methodology) }
}
